import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 3.99973C11.303 3.99973 10.6132 3.738 10.1864 3.18703L9.73424 2.60341C9.12172 1.81277 8.01933 1.59614 7.15318 2.09621L5.84684 2.85043C4.98069 3.3505 4.6171 4.41352 4.99556 5.33929L5.27481 6.0224C5.5387 6.66791 5.42168 7.3929 5.0722 7.99637C4.72303 8.59931 4.15039 9.07013 3.46003 9.16427L2.72977 9.26385C1.7388 9.39898 1 10.2454 1 11.2455V12.754C1 13.7541 1.7388 14.6005 2.72977 14.7356L3.46006 14.8352C4.1504 14.9293 4.72303 15.4001 5.07219 16.0031C5.42166 16.6065 5.53867 17.3315 5.27479 17.977L4.99554 18.6601C4.61708 19.5859 4.98067 20.6489 5.84682 21.149L7.15316 21.9032C8.01931 22.4032 9.1217 22.1866 9.73422 21.396L10.1863 20.8125C10.6131 20.2615 11.303 19.9997 12 19.9997C12.6971 19.9997 13.387 20.2615 13.8139 20.8126L14.2658 21.3958C14.8783 22.1864 15.9807 22.4031 16.8468 21.903L18.1532 21.1488C19.0193 20.6487 19.3829 19.5857 19.0045 18.6599L18.7252 17.9769C18.4614 17.3314 18.5784 16.6065 18.9278 16.003C19.277 15.4001 19.8496 14.9293 20.5399 14.8352L21.2702 14.7356C22.2612 14.6005 23 13.7541 23 12.754V11.2455C23 10.2454 22.2612 9.39898 21.2702 9.26385L20.5399 9.16427C19.8496 9.07013 19.277 8.59932 18.9278 7.9964C18.5784 7.39295 18.4613 6.66799 18.7252 6.0225L19.0044 5.33946C19.3829 4.41369 19.0193 3.35068 18.1532 2.85061L16.8468 2.09639C15.9807 1.59632 14.8783 1.81295 14.2658 2.60359L13.8138 3.18694C13.3869 3.73798 12.697 3.99973 12 3.99973Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSettings;
